import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import useLineLiff from 'hooks/LineLiff';
import request from 'pages/toyotaPremiumOfficialAccount/utils/request';
import toyotaPremiumLogo from '../../../assets/toyotaPremiun/toyota-premium-metalic-logo.svg';
import { ErrorIcon } from '../components/ErrorIcon';

const DEFAULT_ERROR_MESSAGE = '系統忙碌中，請稍後再試';

const checkUserRole = async () => {
  const response = await request.get('/core/is_sales');
  return response.data.data?.is_sales;
};

const ConsultEntry = () => {
  const navigate = useNavigate();
  const { userInfo, errorMsg: liffError } = useLineLiff(
    process.env.REACT_APP_LIFF_ID_CONSULTATION
  );
  const [errorMessage, setErrorMessage] = useState('');
  const [retryKey, setRetryKey] = useState(0);
  const isError = Boolean(errorMessage);

  const handleRetry = useCallback(() => {
    if (liffError) {
      window.location.reload();
      return;
    }
    setErrorMessage('');
    setRetryKey((key) => key + 1);
  }, [liffError]);

  useEffect(() => {
    if (liffError) {
      setErrorMessage(DEFAULT_ERROR_MESSAGE);
      return;
    }
    if (!userInfo) return;

    let cancelled = false;

    const redirectDecision = async () => {
      try {
        const isSales = await checkUserRole();
        if (cancelled) return;
        navigate(
          isSales
            ? '/ToyotaPremium/consultation/conversation-list'
            : '/ToyotaPremium/consultation/branch-list'
        );
      } catch {
        if (!cancelled) {
          setErrorMessage(DEFAULT_ERROR_MESSAGE);
        }
      }
    };

    redirectDecision();
    return () => {
      cancelled = true;
    };
  }, [liffError, navigate, retryKey, userInfo]);

  return (
    <div className="consult-entry" aria-busy={!isError}>
      <div className="consult-entry__panel" role="status" aria-live="polite">
        <div className="consult-entry__glow" aria-hidden="true" />
        <div className="consult-entry__identity">
          <img
            className="consult-entry__logo"
            src={toyotaPremiumLogo}
            alt="TOYOTA PREMIUM"
          />
          <p className="consult-entry__brand">TOYOTA PREMIUM</p>
        </div>
        {isError ? (
          <ErrorIcon />
        ) : (
          <div className="consult-entry__spinner" aria-hidden="true">
            <span className="consult-entry__spinner-ring" />
          </div>
        )}
        <div className="consult-entry__copy">
          <h1 className="consult-entry__title">
            {isError ? '無法進入諮詢' : '專屬諮詢準備中'}
          </h1>
          <p className="consult-entry__description">
            {isError ? errorMessage : '請稍候，正在為您確認服務身分'}
          </p>
        </div>
        {isError && (
          <button
            type="button"
            className="consult-entry__retry"
            onClick={handleRetry}>
            重新嘗試
          </button>
        )}
      </div>
    </div>
  );
};

export default ConsultEntry;
